jQuery(document).ready(function ($) {
  var items = document.querySelectorAll('.car-slider--slider__item')
  if(items.length <= 6) {
    var items_to_show = items.length
    console.log(items_to_show)
  } else {
    items_to_show = 6
  }

  $('.car-slider--slider__items').slick({
    dots: false,
    infinite: true,
    speed: 300,
    slidesToShow: 2,
    slidesToScroll: 1,
    prevArrow: $('.car-slider--slider__nav.prev'),
    nextArrow: $('.car-slider--slider__nav.next'),
    mobileFirst: true,
    draggable: false,
    responsive: [
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 4,
        },
      },
      {
        breakpoint: 992,
        settings: {
          slidesToShow: 5,
        },
      },
      {
        breakpoint: 1200,
        settings: {
          slidesToShow: items_to_show,
        },
      },
    ],
  });
});



// WEBPACK FOOTER //
// ./scripts/car-slider.js